import { Clapperboard, Youtube } from "lucide-react";
import { PageHeader } from "@/components/common/PageHeader";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Paywall } from "@/components/common/Paywall";
import { ReelBuilder } from "@/components/content/ReelBuilder";
import { PublishKit } from "@/components/content/PublishKit";

export default function Content() {
    return (
        <div className="ww-fade-up">
            <PageHeader title="Content Studio" subtitle="Edit clips into reels, then auto-generate the YouTube publish kit." />
            <Paywall tier="creator" feature="Content Studio">
                <Tabs defaultValue="builder" className="w-full">
                    <TabsList className="bg-surface border border-border rounded-sm mb-6">
                        <TabsTrigger value="builder" data-testid="tab-builder" className="data-[state=active]:bg-volt data-[state=active]:text-black rounded-sm gap-2">
                            <Clapperboard className="w-4 h-4" /> Reel Builder
                        </TabsTrigger>
                        <TabsTrigger value="publish" data-testid="tab-publish" className="data-[state=active]:bg-volt data-[state=active]:text-black rounded-sm gap-2">
                            <Youtube className="w-4 h-4" /> Publish Kit
                        </TabsTrigger>
                    </TabsList>
                    <TabsContent value="builder"><ReelBuilder /></TabsContent>
                    <TabsContent value="publish"><PublishKit /></TabsContent>
                </Tabs>
            </Paywall>
        </div>
    );
}
